// The appearance layer: class strings shared by src/components/ui and by any
// page that needs a matching control without a component. Import these rather
// than retyping them; before this module existed the card string was copied
// by hand into 25 files.

// Unconditional outline-none (not focus:outline-none): with a transition on the
// element the outline otherwise animates from currentColor and flashes on click.
// focus-visible so the ring shows for keyboard focus, not after every mouse click.
export const focusRingCls =
  'outline-none focus-visible:ring-2 focus-visible:ring-vein-red-500 focus-visible:ring-offset-2';

// Solid white card on the flat ground: hairline border, no shadow. Shadows are
// reserved for surfaces that float (modals, dropdowns, toasts).
export const cardCls = 'bg-white border border-vein-border rounded-xl';

// The one chart palette, no red; series take colors in this order.
export const chartColors = ['#2563EB', '#7C3AED', '#0891B2', '#64748B'] as const;
